/*
* Palo Alto Theme
*
* Use this file to add custom Javascript to Palo Alto.  Keeping your custom
* Javascript in this fill will make it easier to update Palo Alto. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

  

  // ^^ Keep your scripts inside this IIFE function call to
  // avoid leaking your variables into the global scope.
})();
document.addEventListener('DOMContentLoaded', () => {
  function validateSubscriptionCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        let totalSubscriptionQuantity = 0;
        let hasSubscription = false;

        cart.items.forEach(item => {
          if (item.selling_plan_allocation) {
            hasSubscription = true;
            totalSubscriptionQuantity += item.quantity;
          }
        });

        const checkoutButton = document.querySelector('.cart__checkout');
        const errorMessage = document.querySelector('[data-error-message]');
        const errorContainer = document.querySelector('[data-cart-errors]');

        if (!checkoutButton || !errorMessage || !errorContainer) return;

        if (hasSubscription && totalSubscriptionQuantity < 3) {
          checkoutButton.setAttribute('disabled', 'disabled');
          checkoutButton.classList.add('disabled');
          errorMessage.textContent = 'You must add at least 3 subscription items to checkout.';
          errorContainer.classList.add('is-expanded');
        } else {
          checkoutButton.removeAttribute('disabled');
          checkoutButton.classList.remove('disabled');

          errorMessage.textContent = '';
          errorContainer.classList.remove('is-expanded');
        }
      });
  }

  validateSubscriptionCart();

  document.addEventListener('theme:cart:update', validateSubscriptionCart);
  document.addEventListener('theme:cart:added', validateSubscriptionCart);
});